export enum SignInProvider {
  GOOGLE = 'google.com',
  FACEBOOK = 'facebook.com',
  APPLE = 'apple.com',
  SIGN_IN_EMAIL_AND_PWD = 'password',
  REGISTER_EMAIL_AND_PWD = 'register_email_and_password'
}
